import { render, staticRenderFns } from "./BoletinsMedicoes.vue?vue&type=template&id=09c0a71e&"
import script from "./BoletinsMedicoes.vue?vue&type=script&lang=js&"
export * from "./BoletinsMedicoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports